module.exports = __webpack_public_path__ + "img/pt.1ba4a771.png";